// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.streams-drawer-summary-section .streams-drawer-summary-section-header {
  padding: 0 15px;
}
.streams-drawer-summary-section .cu-icon-sm {
  height: 16px;
  width: 16px;
}
`, "",{"version":3,"sources":["webpack://./app/streams-drawer/streams-drawer-summary-section/streams-drawer-summary-section.less"],"names":[],"mappings":"AAMA;EAGQ,eAAA;AAPR;AAIA;EAOQ,YAAA;EACA,WAAA;AARR","sourcesContent":["//\n// Copyright (c) 2011-2019 by Curalate, Inc.\n//\n\n@import (reference) '../../../css/unison';\n\n.streams-drawer-summary-section {\n\n    .streams-drawer-summary-section-header {\n        padding: 0 15px;\n    }\n\n    .cu-icon-sm {\n        height: @cu-spacing-3;\n        width: @cu-spacing-3;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
